export const COLLECTION_NAME_KEY = 'collectionName';
export const ADD_EVENT_KEY = 'addEvent';
export const EVENTS_LIST_KEY = 'EventList';
export const SET_EVENT_MINTERS_KEY = 'setEventMinters';
export const GET_IS_EVENT_NFTS_MINTERD_KEY = 'getIsEventNftsMinted';
